<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset="5"
    eager
  >
    <template #activator="{ props: menuProps }">
      <button
        @keyup.down="focusOnLabeledVolume(1, 0)"
        v-bind="menuProps"
        ref="childrenMenuActivator"
        :ripple="false"
        class="bg-white c-black fullheight fullwidth rounded pa-3 focus-very-visible"
      >
        <v-row>
          <v-col
            class="ta-left"
            cols="10"
          >
            <div
              class="fs-16 mb-1"
              data-cy="children_dropdown"
            >
              {{ $bct('Children') }}
            </div>
            <div
              v-text="addChildrenText"
              :aria-label="addChildrenLabel"
              class="fs-16 fw-600"
            />
          </v-col>
          <v-col
            class="d-flex align-center justify-end"
            cols="2"
          >
            <v-icon icon="expand_more" />
          </v-col>
        </v-row>
      </button>
    </template>

    <v-card>
      <v-card-text>
        <LabeledVolume
          v-for="(item, index) in ageGroups"
          @decrease="emit('decrease', index)"
          @down="down(index)"
          @increase="emit('increase', index)"
          @up="up(index)"
          :key="index"
          ref="childVolume"
          :autofocus="index == 0"
          :count="item.count"
          :dense="true"
          :subtitle="item.subtitle || item.subtext"
          :title="item.title || item.text"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="close"
          :ripple="false"
          class="focus-very-visible"
          color="primary"
          data-cy="children_done"
        >
          {{ $bct('Done') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup>
import LabeledVolume from '@/shared/components/form/LabeledVolume.vue';

const props = defineProps({
  ageGroups: {
    type: Array,
    default: null,
  },
  autofocus: {
    type: Boolean,
    default: true,
  },
  sum: {
    type: Number,
    default: null,
  },
  value: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close', 'decrease', 'increase']);

const $bct = inject('translator');

const menu = ref(false);
const childrenMenuActivator = ref(null);
const childVolume = ref([]);

const addChildrenText = computed(() => {
  if (props.sum > 0) {
    return [props.sum, props.sum === 1 ? $bct('child') : $bct('children')].join(' ');
  }
  return $bct('Add children');
});

const addChildrenLabel = computed(() => {
  if (props.sum > 0) {
    const str = [];
    props.ageGroups.forEach((item) => {
      if (item.count > 0) {
        str.push([$bct(item.count.toString()), $bct(item.name)].join(' '));
      }
    });
    return str.join(' ');
  }
  return $bct('Add children');
});

onMounted(() => {
  if (!props.autofocus) return;
  focus();
});

const close = () => {
  menu.value = false;
  focus();
  emit('close');
};

const down = (index) => {
  if (index + 1 >= childVolume.value.length) return focusOnLabeledVolume(1, 0);
  return focusOnLabeledVolume(1, index + 1);
};

const focus = () => {
  childrenMenuActivator.value.focus();
};

const focusOnLabeledVolume = (x, y) => {
  childVolume.value[y].focus();
};

const up = (index) => {
  if (index <= 0) return focusOnLabeledVolume(1, childVolume.value.length - 1);
  return focusOnLabeledVolume(1, index - 1);
};
</script>
